
import { useParams } from 'react-router-dom';
import { DescuentosFormState } from '../../../context/descuentos/DescuentosFormState';
import { Form } from './form';

export const DescuentosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Descuento" : "Crear Descuento";

  return (
    <DescuentosFormState>
        <br />
        <Form title={title} />
    </DescuentosFormState>
  );
};
